import { Action } from "@ngrx/store";
import { type } from "../../../util";

export const ActionTypes = {
  FETCH_DRUG_CHECK_STATUS: type('[Drug test check] fetch Drug test check status'),
  STORE_DRUG_CHECK_STATUS: type('[Drug test check] store Drug test check status')
};

export class FetchDrugCheckStatus implements Action {
  public type = ActionTypes.FETCH_DRUG_CHECK_STATUS;

  constructor(public payload?: any) { }
}

export class StoreDrugCheckStatus implements Action {
  public type = ActionTypes.STORE_DRUG_CHECK_STATUS;

  constructor(public payload?: any) { }
}

export type TypeAction =
  StoreDrugCheckStatus;